export default {
  delete: {
    title_account: 'ลบบัญชี',
    title_user: 'ลบบัญชีเข้าใช้งานของฉัน',

    loading: 'กำลังโหลด…',
    load_error: 'ไม่สามารถโหลดสถานะบัญชีได้ กรุณาลองใหม่',

    what_heading: 'สิ่งที่จะถูกลบ',
    what_account:
      'อาคาร ห้อง ผู้เช่า สัญญาเช่า ใบแจ้งหนี้ การชำระเงิน ค่าใช้จ่าย รายการบัญชี เอกสาร และไฟล์ที่อัปโหลดทั้งหมดของบัญชีนี้ รวมถึงบัญชีเข้าใช้งานของทีมงานทุกคน ผู้เช่าจะไม่สามารถเข้าแอปสำหรับลูกค้าได้อีก',
    what_user: 'บัญชีเข้าใช้งานของคุณเท่านั้น บัญชีและข้อมูลอื่นยังอยู่เหมือนเดิม',

    when_heading: 'เมื่อไร',
    when_body: 'ใช้งานไม่ได้ทันที กู้คืนได้จนถึงสิ้นวันที่ {{date}} หลังจากนั้นจะถูกลบถาวร',

    restore_heading: 'วิธีกู้คืน',
    restore_body: 'เข้าสู่ระบบด้วยอีเมลและรหัสผ่านเดิมภายใน {{days}} วัน แล้วเลือกกู้คืนบัญชี',
    restore_owner_only: 'มีเพียงเจ้าของบัญชีเท่านั้นที่กู้คืนบัญชีได้',

    kept_heading: 'สิ่งที่ FlowRent เก็บไว้',
    kept_body:
      'ข้อมูลการเรียกเก็บเงินของ FlowRent สำหรับบัญชีนี้ ซึ่งกฎหมายกำหนดให้ต้องเก็บไว้ และประวัติการแก้ไขชื่อและการตั้งค่าของบัญชี',

    closing_package_suggestion: 'แนะนำให้ดาวน์โหลดชุดเอกสารปิดบัญชีประจำเดือนก่อน',
    closing_package_link: 'ไปที่ชุดเอกสารปิดบัญชี',

    password_label: 'ยืนยันรหัสผ่านของคุณ',
    password_placeholder: 'กรอกรหัสผ่าน',
    toggle_password_visibility: 'แสดงหรือซ่อนรหัสผ่าน',
    password_required: 'กรอกรหัสผ่านเพื่อดำเนินการต่อ',

    submit_account: 'ลบบัญชี',
    submit_user: 'ลบบัญชีเข้าใช้งานของฉัน',

    confirm_title_account: 'ยืนยันลบบัญชีนี้?',
    confirm_title_user: 'ยืนยันลบบัญชีเข้าใช้งานของคุณ?',
    confirm_message_account:
      'บัญชีจะใช้งานไม่ได้ทันที ทั้งทีมงานและผู้เช่าทุกคน และจะถูกลบถาวรหลังจาก {{days}} วัน หลังจากนั้นจะกู้คืนไม่ได้',
    confirm_message_user:
      'บัญชีเข้าใช้งานของคุณจะใช้งานไม่ได้ทันที และจะถูกลบถาวรหลังจาก {{days}} วัน หลังจากนั้นจะกู้คืนไม่ได้',
    confirm_confirm: 'ลบ',
    confirm_cancel: 'ยกเลิก',

    errors: {
      password_invalid: 'รหัสผ่านไม่ถูกต้อง',
    },
  },

  export: {
    title: 'ข้อมูลบัญชีของคุณ',
    lead: 'ดาวน์โหลดไฟล์ด้านล่างทีละไฟล์ ลิงก์แต่ละอันใช้ได้ 15 นาที โหลดหน้านี้ใหม่เพื่อรับลิงก์ใหม่',
    links_expire: 'ลิงก์หมดอายุใน 15 นาที',
    files_deleted_on: 'ไฟล์จะถูกลบวันที่ {{date}}',
    not_owner: 'เฉพาะเจ้าของบัญชีเท่านั้นที่ดาวน์โหลดข้อมูลนี้ได้',
    link_invalid: 'ลิงก์นี้ใช้ไม่ได้หรือหมดอายุแล้ว ติดต่อทีม FlowRent เพื่อขอส่งออกข้อมูลใหม่',
    expired: 'ข้อมูลที่ส่งออกนี้ถูกลบแล้ว ติดต่อทีม FlowRent เพื่อขอส่งออกข้อมูลใหม่',
    load_error: 'โหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่',
  },
}
